// It's like a Popover component but implemented in Vanilla JS
export default class DropdownHandler {
  wrapper;

  // Class which is added on the start, for example with opacity: 0 and display: block, so that the transition can work
  wrapperClassNameStart;

  wrapperClassNameAnimating;

  wrapperClassName;

  dropdown;

  isOpen = false;

  maximumHeight = '100vh';

  isMobile = false;

  animationTime = 300;

  updateHeightTimeout;

  constructor(props) {
    this.dropdown = props.dropdown;
    this.wrapper = props.wrapper;
    this.wrapperClassNameStart = `${props.wrapperClassName}-start`;
    this.wrapperClassNameAnimating = `${props.wrapperClassName}-animating`;
    this.wrapperClassName = props.wrapperClassName;
    this.maximumHeight = props.maximumHeight ? props.maximumHeight : this.maximumHeight;
    this.isMobile = props.isMobile;
    this.setMaxHeight('0');
  }

  startListening() {
    this.wrapper.addEventListener('click', event => {
      const isTargetDropdown = this.dropdown.contains(event.target);
      if (!isTargetDropdown) {
        this.toggleOpen();
      }
    });

    document.addEventListener('click', event => {
      if (!this.isOpen) {
        return;
      }
      const isTargetDropdown = this.wrapper.contains(event.target);
      if (!isTargetDropdown) {
        this.closeDropdown();
      }
    });
  }

  setMaxHeight(value) {
    this.dropdown.style.maxHeight = value;
  }

  updateMaxHeightValue() {
    const height = this.dropdown.getBoundingClientRect().height;
    if (height < 100) {
      return;
    }
    this.maximumHeight = `${height}px`;
    this.setMaxHeight(this.maximumHeight);
  }

  toggleOpen() {
    this.wrapper.setAttribute('disabled', 'true');

    clearTimeout(this.updateHeightTimeout);
    if (this.isOpen) {
      this.closeDropdown();
      return;
    }

    this.isOpen = true;
    this.wrapper.classList.add(this.wrapperClassNameStart);
    this.wrapper.classList.add(this.wrapperClassNameAnimating);

    if (this.isMobile) {
      document.documentElement.style.overflow = 'hidden';
    }

    setTimeout(() => {
      this.wrapper.classList.add(this.wrapperClassName);
      this.setMaxHeight(this.maximumHeight);
    });

    this.updateHeightTimeout = setTimeout(() => {
      this.updateMaxHeightValue();
      this.wrapper.classList.remove(this.wrapperClassNameAnimating);
    }, this.animationTime + 50);

    this.wrapper.removeAttribute('disabled');
  }

  closeDropdown() {
    this.wrapper.setAttribute('disabled', 'true');
    this.isOpen = false;

    if (this.isMobile) {
      document.documentElement.style.overflow = 'visible';
    }

    this.setMaxHeight('0');
    this.wrapper.classList.remove(this.wrapperClassName);
    this.wrapper.classList.add(this.wrapperClassNameAnimating);
    setTimeout(() => {
      this.wrapper.classList.remove(this.wrapperClassNameStart);
      this.wrapper.classList.remove(this.wrapperClassNameAnimating);
      this.wrapper.removeAttribute('disabled');
    }, this.animationTime);
  }
}
